/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { EthGravity, EthGravityInterface } from "../EthGravity";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wethAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gravityAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_destination",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "sendToCronosEthEvent",
    type: "event",
  },
  {
    inputs: [],
    name: "gravity",
    outputs: [
      {
        internalType: "contract Gravity",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_destination",
        type: "address",
      },
    ],
    name: "sendToCronosEth",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IWETH",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class EthGravity__factory {
  static readonly abi = _abi;
  static createInterface(): EthGravityInterface {
    return new utils.Interface(_abi) as EthGravityInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EthGravity {
    return new Contract(address, _abi, signerOrProvider) as EthGravity;
  }
}
